import { render, staticRenderFns } from "./sad-builder.vue?vue&type=template&id=583a8135&"
import script from "./sad-builder.vue?vue&type=script&lang=js&"
export * from "./sad-builder.vue?vue&type=script&lang=js&"
import style0 from "./sad-builder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports